export type QuotationStatus = 'draft' | 'sent' | 'pending_approval' | 'approved' | 'rejected' | 'expired' | 'converted';

export interface QuotationLineItem {
  id: number;
  description: string;
  qty: number;
  unit: string;
  rate: number;
  taxPct: number;
}

export interface Quotation {
  id: number;
  quotationNo: string;
  date: string;
  validUntil: string;
  status: QuotationStatus;
  clientId: number;
  clientName: string;
  clientCompany: string;
  clientEmail: string;
  clientPhone: string;
  clientAddress: string;
  clientGstin: string;
  jobRef: string;
  jobTitle: string;
  jobLocation: string;
  items: QuotationLineItem[];
  notes: string;
  terms: string;
  subtotal: number;
  totalTax: number;
  grandTotal: number;
  convertedJobNo: string | null;
  createdBy: string;
  approvedBy: string | null;
  approvedAt: string | null;
  sentAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export const mockQuotations: Quotation[] = [
  {
    id: 1,
    quotationNo: 'QT-2026-0045',
    date: '2026-04-01',
    validUntil: '2026-04-30',
    status: 'approved',
    clientId: 1,
    clientName: 'Venkat Rao',
    clientCompany: 'HMDA Projects Ltd.',
    clientEmail: 'venkat@hmda.gov.in',
    clientPhone: '+91 98765 43210',
    clientAddress: 'HMDA Office, Punjagutta, Hyderabad - 500082',
    clientGstin: '36AABCH5678G1Z2',
    jobRef: 'HYD-SURV-2026-04-0034',
    jobTitle: 'Topographic Survey - Shamshabad Industrial Zone',
    jobLocation: 'Shamshabad, Hyderabad',
    items: [
      { id: 1, description: 'Topographic Survey (125 Acres @ ₹1,000/Acre)', qty: 125, unit: 'Acres', rate: 1000, taxPct: 18 },
      { id: 2, description: 'CAD Drafting & Drawing Preparation', qty: 1, unit: 'Lump Sum', rate: 25000, taxPct: 18 },
      { id: 3, description: 'Field Mobilization Charges', qty: 1, unit: 'Lump Sum', rate: 15000, taxPct: 18 },
      { id: 4, description: 'Report Preparation & Submission', qty: 1, unit: 'Lump Sum', rate: 10000, taxPct: 18 },
    ],
    notes: 'Quotation valid for 30 days from date of issue. Prices are inclusive of all field and office work.',
    terms: '1. 50% advance payment required on order confirmation.\n2. Balance 50% on delivery of final drawings.\n3. Additional revisions beyond 2 iterations will be charged extra.\n4. All disputes subject to Hyderabad jurisdiction.',
    subtotal: 175000,
    totalTax: 31500,
    grandTotal: 206500,
    convertedJobNo: 'HYD-SURV-2026-04-0034',
    createdBy: 'Priya Sharma',
    approvedBy: 'Venkat Rao',
    approvedAt: '2026-04-03',
    sentAt: '2026-04-02',
    createdAt: '2026-04-01T09:30:00',
    updatedAt: '2026-04-03T14:20:00',
  },
  {
    id: 2,
    quotationNo: 'QT-2026-0046',
    date: '2026-04-03',
    validUntil: '2026-05-03',
    status: 'pending_approval',
    clientId: 4,
    clientName: 'Mohan Das',
    clientCompany: 'Pharma City Development Corp.',
    clientEmail: 'mohan@pharmacityhyd.com',
    clientPhone: '+91 65432 10987',
    clientAddress: 'Genome Valley, Turkapally, Hyderabad - 500101',
    clientGstin: '36AABCP7890J1Z6',
    jobRef: 'HYD-SURV-2026-04-0031',
    jobTitle: 'Drone Survey - Patancheru Industrial Area',
    jobLocation: 'Patancheru, Hyderabad',
    items: [
      { id: 1, description: 'Drone Survey (280 Acres @ ₹800/Acre)', qty: 280, unit: 'Acres', rate: 800, taxPct: 18 },
      { id: 2, description: 'Topographic Survey (280 Acres @ ₹600/Acre)', qty: 280, unit: 'Acres', rate: 600, taxPct: 18 },
      { id: 3, description: 'Orthophoto Processing & Delivery', qty: 1, unit: 'Lump Sum', rate: 35000, taxPct: 18 },
      { id: 4, description: 'GIS Data Export (KMZ/SHP)', qty: 1, unit: 'Lump Sum', rate: 15000, taxPct: 18 },
    ],
    notes: 'Drone flight permissions from AAI will be arranged by our team. Timeline subject to clearance.',
    terms: '1. 40% advance on PO.\n2. 30% on completion of field work.\n3. Balance 30% on final delivery.\n4. AAI clearance delays not attributable to us.',
    subtotal: 386000,
    totalTax: 69480,
    grandTotal: 455480,
    convertedJobNo: null,
    createdBy: 'Priya Sharma',
    approvedBy: null,
    approvedAt: null,
    sentAt: '2026-04-04',
    createdAt: '2026-04-03T11:00:00',
    updatedAt: '2026-04-04T09:15:00',
  },
  {
    id: 3,
    quotationNo: 'QT-2026-0044',
    date: '2026-03-25',
    validUntil: '2026-04-24',
    status: 'sent',
    clientId: 6,
    clientName: 'Ramesh Goud',
    clientCompany: 'Telangana State Housing Corp.',
    clientEmail: 'ramesh@tshc.gov.in',
    clientPhone: '+91 43210 98765',
    clientAddress: 'TSHC Office, Masab Tank, Hyderabad - 500028',
    clientGstin: '36AABCT6789L1Z3',
    jobRef: '',
    jobTitle: 'Land Demarcation - Housing Colony',
    jobLocation: 'Shamshabad, Hyderabad',
    items: [
      { id: 1, description: 'Boundary Demarcation (120 plots)', qty: 120, unit: 'Plots', rate: 1200, taxPct: 18 },
      { id: 2, description: 'Pillar Fixing (RCC)', qty: 120, unit: 'Nos', rate: 350, taxPct: 18 },
      { id: 3, description: 'Survey Report with Coordinates', qty: 1, unit: 'Lump Sum', rate: 15000, taxPct: 18 },
    ],
    notes: 'Government tender rates applicable. GST extra as per invoice.',
    terms: '1. Work commencement within 15 days of PO.\n2. Payment within 30 days of invoice.\n3. TDS deduction as per government norms.',
    subtotal: 196200,
    totalTax: 35316,
    grandTotal: 231516,
    convertedJobNo: null,
    createdBy: 'Amit Patel',
    approvedBy: null,
    approvedAt: null,
    sentAt: '2026-03-26',
    createdAt: '2026-03-25T10:00:00',
    updatedAt: '2026-03-26T08:30:00',
  },
  {
    id: 4,
    quotationNo: 'QT-2026-0043',
    date: '2026-03-20',
    validUntil: '2026-04-19',
    status: 'expired',
    clientId: 5,
    clientName: 'Anitha Krishnan',
    clientCompany: 'Infra Builders Ltd.',
    clientEmail: 'anitha@infrabuilders.in',
    clientPhone: '+91 54321 09876',
    clientAddress: 'Kukatpally Housing Board, Hyderabad - 500072',
    clientGstin: '36AABCI2345K1Z0',
    jobRef: '',
    jobTitle: 'Hydrogeological Survey - Kukatpally',
    jobLocation: 'Kukatpally, Hyderabad',
    items: [
      { id: 1, description: 'Hydrogeological Survey (12 km)', qty: 12, unit: 'km', rate: 12000, taxPct: 18 },
      { id: 2, description: 'Groundwater Report', qty: 1, unit: 'Lump Sum', rate: 20000, taxPct: 18 },
    ],
    notes: 'Includes borehole data analysis and aquifer mapping.',
    terms: '1. 50% advance required.\n2. Balance on report delivery.',
    subtotal: 164000,
    totalTax: 29520,
    grandTotal: 193520,
    convertedJobNo: null,
    createdBy: 'Priya Sharma',
    approvedBy: null,
    approvedAt: null,
    sentAt: '2026-03-21',
    createdAt: '2026-03-20T14:00:00',
    updatedAt: '2026-03-21T10:00:00',
  },
  {
    id: 5,
    quotationNo: 'QT-2026-0047',
    date: '2026-04-05',
    validUntil: '2026-05-05',
    status: 'draft',
    clientId: 8,
    clientName: 'Srinivas Rao',
    clientCompany: 'AP State Roads Dev. Corp.',
    clientEmail: 'srinivas@apsrdc.gov.in',
    clientPhone: '+91 21098 76543',
    clientAddress: 'Vijayawada, Andhra Pradesh - 520001',
    clientGstin: '37AABCA8901N1Z1',
    jobRef: 'HYD-SURV-2026-04-0030',
    jobTitle: 'Hydrogeological Survey - Vijayawada Highway',
    jobLocation: 'Vijayawada, AP',
    items: [
      { id: 1, description: 'DGPS Survey (85 km)', qty: 85, unit: 'km', rate: 8000, taxPct: 18 },
      { id: 2, description: 'Hydrogeological Survey (85 km)', qty: 85, unit: 'km', rate: 12000, taxPct: 18 },
      { id: 3, description: 'Report & GIS Data Package', qty: 1, unit: 'Lump Sum', rate: 45000, taxPct: 18 },
    ],
    notes: 'Mobilization from Hyderabad. Travel and accommodation extra.',
    terms: '1. 50% advance on PO.\n2. Balance on final report delivery.',
    subtotal: 1765000,
    totalTax: 317700,
    grandTotal: 2082700,
    convertedJobNo: null,
    createdBy: 'Priya Sharma',
    approvedBy: null,
    approvedAt: null,
    sentAt: null,
    createdAt: '2026-04-05T16:00:00',
    updatedAt: '2026-04-05T16:00:00',
  },
  {
    id: 6,
    quotationNo: 'QT-2026-0042',
    date: '2026-03-15',
    validUntil: '2026-04-14',
    status: 'rejected',
    clientId: 3,
    clientName: 'Kavitha Reddy',
    clientCompany: 'Prestige Estates Pvt. Ltd.',
    clientEmail: 'kavitha@prestige.com',
    clientPhone: '+91 76543 21098',
    clientAddress: 'Prestige Tower, Banjara Hills, Hyderabad - 500034',
    clientGstin: '36AABCP3456I1Z4',
    jobRef: '',
    jobTitle: 'As-Built Survey - Prestige Towers',
    jobLocation: 'Banjara Hills, Hyderabad',
    items: [
      { id: 1, description: 'As-Built Survey (G+20 Building)', qty: 1, unit: 'Lump Sum', rate: 85000, taxPct: 18 },
      { id: 2, description: 'CAD Drawings (All Floors)', qty: 20, unit: 'Floors', rate: 2500, taxPct: 18 },
    ],
    notes: 'Includes all floor plans and elevation drawings.',
    terms: '1. 50% advance.\n2. Balance on delivery.',
    subtotal: 135000,
    totalTax: 24300,
    grandTotal: 159300,
    convertedJobNo: null,
    createdBy: 'Amit Patel',
    approvedBy: null,
    approvedAt: null,
    sentAt: '2026-03-16',
    createdAt: '2026-03-15T09:00:00',
    updatedAt: '2026-03-18T11:00:00',
  },
  {
    id: 7,
    quotationNo: 'QT-2026-0041',
    date: '2026-03-10',
    validUntil: '2026-04-09',
    status: 'converted',
    clientId: 2,
    clientName: 'Suresh Babu',
    clientCompany: 'NHAI Contractors Pvt. Ltd.',
    clientEmail: 'suresh@nhai.org',
    clientPhone: '+91 87654 32109',
    clientAddress: 'NH-44, Shamshabad, Hyderabad - 501218',
    clientGstin: '36AABCN9012H1Z8',
    jobRef: 'HYD-SURV-2026-04-0033',
    jobTitle: 'DGPS Survey - Outer Ring Road Alignment',
    jobLocation: 'ORR, Hyderabad',
    items: [
      { id: 1, description: 'DGPS Survey (42 km)', qty: 42, unit: 'km', rate: 8000, taxPct: 18 },
      { id: 2, description: 'CAD Drafting & Alignment Drawing', qty: 1, unit: 'Lump Sum', rate: 35000, taxPct: 18 },
      { id: 3, description: 'KMZ Export & GIS Data', qty: 1, unit: 'Lump Sum', rate: 10000, taxPct: 18 },
    ],
    notes: 'Coordinate with NHAI field team for access permissions.',
    terms: '1. 50% advance on PO.\n2. Balance on final delivery.',
    subtotal: 381000,
    totalTax: 68580,
    grandTotal: 449580,
    convertedJobNo: 'HYD-SURV-2026-04-0033',
    createdBy: 'Priya Sharma',
    approvedBy: 'Suresh Babu',
    approvedAt: '2026-03-12',
    sentAt: '2026-03-11',
    createdAt: '2026-03-10T10:00:00',
    updatedAt: '2026-03-12T15:00:00',
  },
];
